import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { PreviewsMergeProps } from '../../../types/reduxTypes/previewsMerge';

const createReducer = <T extends SliceCaseReducers<PreviewsMergeProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setPreviewsMergeData(state, action) {
    state.previewsMergeData = action.payload;
  },
  setPreviewsMergeStatus(state, action) {
    state.previewsMergeStatus = action.payload;
  }
});

export default reducers;
